import clsx from "classnames";
import { Container } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import ChevronLeft from "@/assets/ChevronLeft.svg";
import ChevronRight from "@/assets/ChevronRight.svg";
import { Description, Image, Title } from "@/ui";
import CTA from "@/ui/CTA";
import classes from "./styles.module.scss";

export const IconCardGrid = ({
  className,
  bgColor,
  title,
  titleColor,
  iconPosition: defaultIconPosition = "top",
  items = [],
  button,
}) => {
  if (!items || items.length === 0) return null;

  const ctaList = Array.isArray(button) ? button : button ? [button] : [];

  return (
    <div className={clsx(className, bgColor, classes.iconCardGrid)}>
      <Container className="mw-xxl">
        {title && (
          <Title title={title} className={clsx(titleColor, "text-center mb-4 mb-md-5")} />
        )}
        <div className={classes.iconCardGrid__sliderWrapper}>
          <button className={clsx(classes.iconCardGrid__nav, classes.iconCardGrid__navPrev, "iconCardGrid-prev")}>
            <ChevronLeft width="14" height="25" />
          </button>
          <Swiper
            modules={[Navigation]}
            slidesPerView={1}
            slidesPerGroup={1}
            spaceBetween={16}
            navigation={{
              prevEl: ".iconCardGrid-prev",
              nextEl: ".iconCardGrid-next",
            }}
            breakpoints={{
              576: { slidesPerView: 2, spaceBetween: 16 },
              992: { slidesPerView: 3, spaceBetween: 20 },
              1200: { slidesPerView: 4, spaceBetween: 24 },
            }}
            className={classes.iconCardGrid__swiper}
          >
            {items.map(({ icon, iconPosition, title: cardTitle, description, cardBgColor, cardTextColor }, k) => {
              const pos = iconPosition || defaultIconPosition;
              return (
                <SwiperSlide key={k}>
                  <div
                    className={clsx(
                      cardBgColor,
                      cardTextColor,
                      classes.iconCardGrid__card,
                      pos === "bottom" && classes["iconCardGrid__card--iconBottom"]
                    )}
                  >
                    {icon?.url && (
                      <div className={classes.iconCardGrid__icon}>
                        <Image img={icon.url} size="60x60" alt="" />
                      </div>
                    )}
                    <div className={classes.iconCardGrid__body}>
                      {cardTitle && (
                        <Title title={cardTitle} tag="h3" className="h5 fw-bold mb-2" />
                      )}
                      <Description description={description} />
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
          <button className={clsx(classes.iconCardGrid__nav, classes.iconCardGrid__navNext, "iconCardGrid-next")}>
            <ChevronRight width="14" height="25" />
          </button>
        </div>
        {ctaList.length > 0 && (
          <div className={clsx("d-flex justify-content-center mt-4 mt-md-5", classes.iconCardGrid__cta)}>
            {ctaList.map((btn, k) => (
              <CTA
                key={k}
                label={btn.label}
                href={btn.href}
                variant={btn.variant || "tertiary"}
                target={btn.open_in_new_tab ? "_blank" : undefined}
              />
            ))}
          </div>
        )}
      </Container>
    </div>
  );
};

export default IconCardGrid;
